export default function getResource(label, vars = []) {
    const resources = { view12More: 'Afficher 12 autres' };
    return resources[label];
}
